import { render, staticRenderFns } from "./SetupStep3.vue?vue&type=template&id=7d108528"
import script from "./SetupStep3.vue?vue&type=script&lang=js"
export * from "./SetupStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports